import { AuthenticationUser, CurrencyEnum } from '@codezo/graphql';
import type { OrganizationUserType } from '../hooks/useAuth';

/**
 * Flattens the backend's authentication user into the shape this app's auth
 * context holds. Shared by the standard login callbacks and the guest flow,
 * which hydrates its own session rather than routing through /auth/reauth.
 */
export function formatLoginUser(user: AuthenticationUser): OrganizationUserType {
	const orgUser = user.organizationUser;
	const org = orgUser?.organization;
	const orgSetting = org?.organizationSetting;

	return {
		id: user.id,
		email: user.email || '',
		role: user.role,
		organizationId: orgUser?.organizationId || '',
		organization: {
			id: orgUser?.organizationId || '',
			name: org?.name || '',
			onboarded: org?.onboarded ?? false,
			organizationSetting: {
				currency: orgSetting?.currency || CurrencyEnum.Dkk,
			},
		},
		organizationUser: {
			id: orgUser?.id || '',
			firstName: orgUser?.firstName || '',
			lastName: orgUser?.lastName || '',
		},
	};
}
